<template>
  <div class="base-height_fullscreen">
    <div class="base-flex__between base-margin__bottom-10">
      <el-button type="primary" @click="createInstanceTemplateButton('add', {})"
        >{{ $t('multiCloudCluster.createInstanceTemplate') }}
      </el-button>
      <div class="base-flex">
        <el-select
          v-model="cloudType"
          :placeholder="$t('multiCloudCluster.selectCloudType')"
          clearable
          @change="getInstanceTemplateList"
        >
          <el-option v-for="item in providerOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input
          v-model="searchName"
          :placeholder="$t('multiCloudCluster.inputName')"
          class="base-margin__left-10"
          debounce="400"
          clearable
          @change="getInstanceTemplateList"
        ></el-input>
      </div>
    </div>
    <div class="table_box">
      <el-table :data="instanceTemplateList" v-loading="instanceTemplateListLoading" class="table">
        <el-table-column label="ID" prop="Id"></el-table-column>
        <el-table-column label="名称" prop="Name"></el-table-column>
        <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.cloudProvider')">
          <template slot-scope="scope">
            <div class="provider_div base-flex__cross-center">
              <img v-if="scope.row.Provider === 'aliyun'" src="@/views/multiCloudCluster/image/aliyun.svg" />
              <img v-if="scope.row.Provider === 'huaweicloud'" src="@/views/multiCloudCluster/image/huawei.svg" />
              <img v-if="scope.row.Provider === 'volcengine'" src="@/views/multiCloudCluster/image/volcengine.svg" />
              <span class="base-margin__left-8">{{ filterProviderList(scope.row.Provider) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="地区" prop="Region"></el-table-column>
        <el-table-column label="区域" prop="Zone"></el-table-column>
        <el-table-column label="计费方式" prop="InstanceChargeType">
          <template slot-scope="scope">
            {{ filterMultiCloudBillingTypeData(scope.row.InstanceChargeType) }}
          </template>
        </el-table-column>
        <el-table-column label="实例类型" prop="InstanceType"></el-table-column>
        <el-table-column label="镜像" prop="ImageId"></el-table-column>
        <el-table-column label="系统盘">
          <template slot-scope="scope">
            {{ scope.row.DiskSpecs[0].diskType + ' | ' + scope.row.DiskSpecs[0].diskSize }} GiB
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="Description"></el-table-column>
        <el-table-column label="创建时间" prop="CreateTime"></el-table-column>
        <el-table-column :label="$t('ipManagement.actions')" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="createInstanceTemplateButton('copy', scope.row)">{{ $t('backstage.copy') }}</el-button>
            <el-button type="text" @click="deleteInstanceTemplate(scope.row.Id)">{{
              $t('ipManagement.delete')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="instanceTemplateListPage"
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="instanceTemplateListTotal"
        align="right"
        class="base-margin__top-10"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="partitionSizeChange"
        @current-change="partitionCurrentChange"
      >
      </el-pagination>
    </div>

    <!--创建实例模版弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('multiCloudCluster.createInstanceTemplate')"
      :visible.sync="createInstanceTemplateDialogVisible"
      width="700px"
      @close="closeCreateInstanceTemplate"
    >
      <div>
        <el-form
          ref="instanceTemplateForm"
          v-loading="instanceTemplateFormLoading"
          :rules="instanceTemplateFormRules"
          :model="instanceTemplateForm"
          label-width="100px"
        >
          <!-- 模板名称 -->
          <el-form-item label="模板名称" prop="name">
            <el-input
              v-model="instanceTemplateForm.name"
              class="base-width__320"
              placeholder="请输入模板名称"
            ></el-input>
          </el-form-item>

          <!-- 云服务商 -->
          <el-form-item :label="$t('multiCloudCluster.cloudProvider')" prop="multiCloudAccountId">
            <el-select
              v-model="instanceTemplateForm.multiCloudAccountId"
              :placeholder="$t('multiCloudCluster.selectCloudType')"
              class="base-width__320"
              @change="getRegionsList"
            >
              <el-option
                v-for="item in cloudEnvironmentList"
                :key="item.Id"
                :label="providerList[item.Provider]"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 地区 区域 -->
          <el-form-item :label="$t('multiCloudCluster.region')" prop="zone">
            <div class="base-flex base-width_fullscreen">
              <el-select
                v-model="instanceTemplateForm.region"
                :placeholder="$t('multiCloudCluster.selectRegion')"
                class="base-width__300 base-margin__right-10"
                filterable
                @change="getZones"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.regionId"
                  :label="item.regionName"
                  :value="item.regionId"
                ></el-option>
              </el-select>
              <el-select
                v-model="instanceTemplateForm.zone"
                @change="changeZones"
                :placeholder="$t('customCluster.createCluster.placeholder.selectZone')"
                class="base-width__320"
                filterable
              >
                <el-option v-for="item in zoneList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 计费方式 -->
          <el-form-item :label="$t('customCluster.createCluster.form.billingMethod')" prop="instanceChargeType">
            <el-select
              v-model="instanceTemplateForm.instanceChargeType"
              :placeholder="$t('customCluster.createCluster.placeholder.selectBillingMethod')"
              class="select-width"
              @change="changeBillingValue"
            >
              <el-option
                v-for="item in multiCloudBillingTypeData"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 实例类型 -->
          <el-form-item :label="$t('customCluster.createCluster.form.instanceType')" prop="instanceType">
            <el-select
              v-model="instanceTemplateForm.instanceType"
              filterable
              @change="getImageAndDist"
              :placeholder="$t('customCluster.createCluster.placeholder.selectInstanceType')"
              class="select-width"
            >
              <el-option
                v-for="item in availableResourceList"
                :disabled="item.disabled"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 镜像 -->
          <el-form-item :label="$t('customCluster.createCluster.form.image')" prop="imageId">
            <div class="base-flex base-width_fullscreen">
              <el-select
                v-model="instanceTemplateForm.imageVisibility"
                :placeholder="$t('customCluster.createCluster.placeholder.imageType')"
                class="formItem__select-short base-margin__right-20"
                @change="changeImageType"
              >
                <el-option :label="$t('customCluster.createCluster.option.customImage')" value="private"></el-option>
                <el-option :label="$t('customCluster.createCluster.option.publicImage')" value="public"></el-option>
                <el-option :label="$t('customCluster.createCluster.option.sharedImage')" value="shared"></el-option>
              </el-select>
              <el-select
                v-model="instanceTemplateForm.imageId"
                filterable
                @change="changeImage"
                :placeholder="$t('customCluster.createCluster.placeholder.selectImage')"
                class="select-width"
              >
                <el-option v-for="item in imageList" :key="item.ImageId" :label="item.ImageName" :value="item.ImageId">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 系统盘表单项 -->
          <el-form-item :label="$t('createNode.systemDisk')" prop="diskType">
            <div class="base-flex base-width_fullscreen">
              <!-- 磁盘类型选择 -->
              <el-select
                v-model="instanceTemplateForm.diskType"
                @change="changeDiskType"
                :placeholder="$t('customCluster.createCluster.placeholder.selectSystemDisk')"
                class="base-width__320"
              >
                <el-option v-for="item in diskList" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
              <!-- 磁盘大小输入 -->
              <el-input-number
                v-model="instanceTemplateForm.diskSize"
                :min="diskSizeMinNumber"
                prop="diskSize"
                class="base-width__170 base-margin__left-10"
              />
              GIB
            </div>
          </el-form-item>

          <!-- 磁盘类型为ESSD2或GPSSD2时，显示IOPS和吞吐量 -->
          <el-form-item v-if="instanceTemplateForm.diskType === 'ESSD2' || instanceTemplateForm.diskType === 'GPSSD2'">
            <div class="base-flex base-width_fullscreen">
              <div>
                IOPS:
                <el-input-number
                  v-model="instanceTemplateForm.iops"
                  :min="iopsMinNumber"
                  :max="iopsMaxNumber"
                  prop="iops"
                  class="base-width__170 base-margin__left-10"
                />
              </div>
              <div class="base-margin__left-20">
                吞吐量:
                <el-input-number
                  v-model="instanceTemplateForm.throughput"
                  :min="throuhputMinNumber"
                  :max="throuhputMaxNumber"
                  prop="throughput"
                  class="base-width__170 base-margin__left-10"
                />
              </div>
            </div>
          </el-form-item>

          <el-form-item label="描述">
            <el-input
              v-model="instanceTemplateForm.description"
              class="base-width__320"
              maxlength="200"
              placeholder="请输入模板描述"
              rows="4"
              show-word-limit
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createInstanceTemplateDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="createInstanceTemplate" :loading="createInstanceTemplateConfirmLoading">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { multiCloudBillingTypeData, providerOptions, filterMultiCloudBillingTypeData } from '@/common/constants';
import { postRequest } from '@/common/libs/request';
import { mapGetters, mapState } from 'vuex';
import { extractRegionName, filterProviderList } from '@/common/utils/utils';

export default {
  name: 'instanceTemplate',
  data() {
    return {
      // 实例模版列表
      instanceTemplateList: [],
      instanceTemplateListLoading: false,
      cloudType: '',
      searchName: '',
      providerOptions,
      filterProviderList,
      filterMultiCloudBillingTypeData,
      instanceTemplateListTotal: 0,
      instanceTemplateListLimit: 10,
      instanceTemplateListPage: 1,
      // 创建实例模版弹窗
      createInstanceTemplateConfirmLoading: false,
      createInstanceTemplateDialogVisible: false,
      instanceTemplateFormLoading: false,
      providerList: {
        aliyun: this.$t('multiCloudCluster.aliyun'),
        huaweicloud: this.$t('multiCloudCluster.huaweicloud'),
        volcengine: this.$t('multiCloudCluster.volcengine'),
      },
      multiCloudBillingTypeData,
      regionOptions: [],
      cloudEnvironmentList: [],
      zoneList: [],
      availableResourceList: [],
      imageList: [],
      diskList: [],
      instanceTemplateForm: {
        name: '',
        region: '',
        description: '',
        zone: '',
        instanceType: '',
        imageVisibility: 'public',
        instanceChargeType: '',
        imageId: '',
        multiCloudAccountId: '',
        diskType: '',
        diskSize: '',
        throughput: '',
        iops: '',
      },
      provider: '',
      instanceTemplateFormRules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        region: [{ required: true, message: '请选择区域', trigger: 'change' }],
        zone: [{ required: true, message: '请选择可用区', trigger: 'change' }],
        instanceType: [{ required: true, message: '请选择实例类型', trigger: 'change' }],
        instanceChargeType: [{ required: true, message: '请选择实例计费类型', trigger: 'change' }],
        imageId: [{ required: true, message: '请选择镜像', trigger: 'change' }],
        diskType: [{ required: true, message: '请选择磁盘类型', trigger: 'change' }],
        multiCloudAccountId: [{ required: true, message: '请选择云环境类型', trigger: 'change' }],
      },
      diskSizeMinNumber: 20,
      projectId: '',
      currentProject: {},
      throuhputMinNumber: 1,
      throuhputMaxNumber: 1,
      iopsMinNumber: 1,
      iopsMaxNumber: 1,
      createType: 'add',
    };
  },

  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.instanceTemplateListLimit = 10;
        this.instanceTemplateListPage = 1;
        this.projectId = val.id;
        this.currentProject = val;
        this.getInstanceTemplateList();
      }
    },
  },
  mounted() {
    // 获取项目id
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.currentProject = currentProject;
    this.getInstanceTemplateList();
  },

  methods: {
    /**
     * 创建实例模版
     **/
    createInstanceTemplate() {
      this.$refs.instanceTemplateForm.validate((valid) => {
        if (valid) {
          this.createInstanceTemplateConfirmLoading = true;
          this.instanceTemplateFormLoading = true;
          const params = {
            ...this.instanceTemplateForm,
            diskSpecs: [
              {
                diskKind: 'system',
                diskSize: this.instanceTemplateForm.diskSize,
                diskType: this.instanceTemplateForm.diskType,
                iops: this.instanceTemplateForm.iops,
                throughput: this.instanceTemplateForm.throughput,
              },
            ],
            provider: this.provider,
          };
          if (!(this.instanceTemplateForm.diskType === 'ESSD2' || this.instanceTemplateForm.diskType === 'GPSSD2')) {
            delete params.diskSpecs[0].iops;
            delete params.diskSpecs[0].throughput;
            delete params.iops;
            delete params.throughput;
          }
          postRequest('/api/eda/common/multicloud/createLaunchTemplate', params)
            .then(() => {
              this.instanceTemplateFormLoading = false;
              this.createInstanceTemplateConfirmLoading = false;
              this.$message.success('创建实例模板成功');
              this.createInstanceTemplateDialogVisible = false;
              this.getInstanceTemplateList();
            })
            .catch(() => {
              this.createInstanceTemplateConfirmLoading = false;
              this.instanceTemplateFormLoading = false;
            });
        }
      });
    },

    /**
     * 删除实例模版
     * @param {string} id 实例模版id
     **/
    deleteInstanceTemplate(id) {
      const params = {
        launchTemplateId: id,
      };
      this.$confirm('确定删除该实例模版吗？', this.$t('computingCluster.imagesManage.tip'), {
        confirmButtonText: this.$t('computingCluster.clusterEnv.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/multicloud/deleteLaunchTemplate', params).then(() => {
            this.$message.success('删除实例模板成功');
            this.getInstanceTemplateList();
          });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    /**
     * 获取实例模版列表
     **/
    getInstanceTemplateList() {
      const offset = this.instanceTemplateListLimit * (this.instanceTemplateListPage - 1);
      const params = {
        offset,
        limit: this.instanceTemplateListLimit,
        filters: [],
      };
      if (this.cloudType) {
        const obj = {};
        obj.name = 'provider';
        obj.values = [this.cloudType];
        params.filters.push(obj);
      }
      if (this.searchName) {
        const obj = {};
        obj.name = 'name';
        obj.values = [this.searchName];
        params.filters.push(obj);
      }
      postRequest('/api/eda/common/multicloud/describeLaunchTemplateList', params).then((res) => {
        this.instanceTemplateList = res.launchTemplateList || [];
        this.instanceTemplateListTotal = res.totalCount;
      });
    },

    /**
     * 分页器每页条数改变
     */
    partitionSizeChange(limit) {
      this.instanceTemplateListPage = 1;
      this.instanceTemplateListLimit = limit;
      this.getInstanceTemplateList();
    },

    /**
     * 分页器当前页改变
     */
    partitionCurrentChange(currentPage) {
      this.instanceTemplateListPage = currentPage;
      this.getInstanceTemplateList();
    },

    /**
     * 创建实例模版 按钮
     **/
    async createInstanceTemplateButton(type, item) {
      await this.getMultiCloudAccountList();
      this.createType = type;
      if (type === 'copy') {
        this.provider = item.Provider;
        this.instanceTemplateForm.multiCloudAccountId = item.MultiCloudAccountId;
        this.instanceTemplateForm.name = item.Name;
        this.instanceTemplateForm.region = item.Region;
        this.instanceTemplateForm.zone = item.Zone;
        this.instanceTemplateForm.instanceType = item.InstanceType;
        this.instanceTemplateForm.instanceChargeType = item.InstanceChargeType;
        this.instanceTemplateForm.imageId = item.ImageId;
        this.instanceTemplateForm.diskType = item.DiskSpecs?.[0]?.diskType || '';
        this.instanceTemplateForm.diskSize = item.DiskSpecs?.[0]?.diskSize || '';
        this.instanceTemplateForm.imageVisibility = item.ImageVisibility;
        this.instanceTemplateForm.description = item?.Description || '';
        await this.getRegionsList(type, item);
      }
      this.createInstanceTemplateDialogVisible = true;
    },

    /**
     * 创建实例模版 关闭
     **/
    closeCreateInstanceTemplate() {
      this.instanceTemplateForm = {
        provider: '',
        name: '',
        region: '',
        description: '',
        zone: '',
        instanceType: '',
        instanceChargeType: '',
        imageId: '',
        multiCloudAccountId: '',
        diskType: '',
        diskSize: '',
        imageVisibility: 'public',
      };
      this.regionOptions = [];
      this.cloudEnvironmentList = [];
      this.zoneList = [];
      this.availableResourceList = [];
      this.imageList = [];
      this.diskList = [];
      this.$refs.instanceTemplateForm.resetFields();
      this.createInstanceTemplateDialogVisible = false;
    },

    /**
     * 获取地区列表
     */
    getRegionsList(type, item) {
      if (type !== 'copy') {
        this.instanceTemplateForm.region = '';
        this.instanceTemplateForm.zone = '';
        this.instanceTemplateForm.instanceType = '';
        this.instanceTemplateForm.instanceChargeType = '';
        this.instanceTemplateForm.imageId = '';
        this.instanceTemplateForm.diskType = '';
        this.instanceTemplateForm.diskSize = '';
        this.instanceTemplateForm.description = '';
        this.provider = this.cloudEnvironmentList.find(item => item.Id === this.instanceTemplateForm.multiCloudAccountId).Provider;
      } else {
        setTimeout(() => {
          this.getZones(type);
          this.getImageList(type);
          this.getDiskList(type);
          this.changeBillingValue(type);
          this.changeDiskType(type);
          this.instanceTemplateForm.iops = item.DiskSpecs[0].iops;
          this.instanceTemplateForm.throughput = item.DiskSpecs[0].throughput;
        }, 2000);
      }

      this.instanceTemplateFormLoading = true;
      postRequest('/api/eda/common/multicloud/describeRegions', {
        multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
      })
        .then((res) => {
          if (res.regions) {
            const regionList = [];
            res.regions.forEach((item) => {
              if (item.enable) {
                regionList.push(item);
              }
            });
            this.regionOptions = regionList;
            this.instanceTemplateFormLoading = false;
          }
        })
        .catch(() => {
          this.instanceTemplateFormLoading = false;
        });
    },

    /**
     * 获取地域
     */
    getZones(type) {
      if (type !== 'copy') {
        this.instanceTemplateForm.zone = '';
        this.instanceTemplateForm.instanceType = '';
        this.instanceTemplateForm.instanceChargeType = '';
        this.instanceTemplateForm.imageId = '';
        this.instanceTemplateForm.diskType = '';
        this.instanceTemplateForm.diskSize = '';
        this.instanceTemplateForm.description = '';
      }
      const regionName = extractRegionName(this.regionOptions.find(item => item.regionId === this.instanceTemplateForm.region).regionName);
      this.instanceTemplateFormLoading = true;
      this.zoneList = [];
      if (this.provider === 'volcengine') {
        postRequest('/api/eda/common/volcengine/describeZones', {
          multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
          region: this.instanceTemplateForm.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'aliyun') {
        postRequest('/api/eda/common/aliyun/describeZones', {
          multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
          region: this.instanceTemplateForm.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'huaweicloud') {
        postRequest('/api/eda/common/huaweicloud/describeZones', {
          multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
          region: this.instanceTemplateForm.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));

            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }
    },

    /**
     * 区域变化时重置相关表单字段
     */
    changeZones() {
      this.instanceTemplateForm.instanceType = '';
      this.instanceTemplateForm.instanceChargeType = '';
      this.instanceTemplateForm.imageId = '';
      this.instanceTemplateForm.diskType = '';
      this.instanceTemplateForm.diskSize = '';
      this.instanceTemplateForm.description = '';
    },

    /**
     * 获取实例类型
     */
    changeBillingValue(type) {
      if (type !== 'copy') {
        this.instanceTemplateForm.instanceType = '';
      }
      const params = {
        multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
        region: this.instanceTemplateForm.region,
        zone: this.instanceTemplateForm.zone,
        destinationResource: 'InstanceType',
        instanceChargeType: this.instanceTemplateForm.instanceChargeType,
      };

      if (this.provider === 'volcengine') {
        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/volcengine/describeInstanceTypes', params)
          .then((res) => {
            const instanceTypeIdList = res.instanceTypeList.map((item) => {
              const name = `${item.instanceTypeSpec.Processor.Cpus}核  ${
                item.instanceTypeSpec.Memory.Size / 1024
              }GB | ${item.instanceTypeSpec.InstanceTypeId}`;
              return {
                value: item.instanceTypeSpec.InstanceTypeId,
                name: item.status === 'Available' ? name : `${name} (${this.$t('createNode.soldOut')})`,
                disabled: item.status !== 'Available',
              };
            }) || [];
            this.availableResourceList = instanceTypeIdList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'aliyun') {
        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/aliyun/describeAvailableResource', params)
          .then((res) => {
            const instanceTypeIdList
              = res.availableResourceList[0].AvailableResources.AvailableResource[0].SupportedResources.SupportedResource.map(item => ({
                name: item.Status === 'Available' ? item.Value : `${item.Value} (${this.$t('createNode.soldOut')})`,
                value: item.Value,
                disabled: item.Status !== 'Available',
              })) || [];
            this.availableResourceList = instanceTypeIdList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'huaweicloud') {
        this.instanceTemplateFormLoading = true;
        delete params.destinationResource;
        postRequest('/api/eda/common/huaweicloud/describeInstanceTypes', params)
          .then((res) => {
            const instanceTypeIdList
              = res.flavorInfoList.map((item) => {
                const name = `${item.vcpus}核  ${item.ram / 1024}GB | ${item.id}`;
                return {
                  name,
                  value: item.id,
                };
              }) || [];
            this.availableResourceList = instanceTypeIdList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }
    },

    /**
     * 获取镜像列表和distList
     */
    getImageAndDist() {
      this.instanceTemplateForm.imageId = '';
      this.instanceTemplateForm.diskSpecs = { diskKind: 'system', diskSize: '', diskType: '' };
      this.getImageList();
      this.getDiskList();
    },

    changeImageType() {
      this.instanceTemplateForm.imageId = '';
      this.getImageList();
    },

    /**
     * 获取系统盘
     */
    getDiskList() {
      const params = {
        multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
        region: this.instanceTemplateForm.region,
        zone: this.instanceTemplateForm.zone,
        instanceTypeId: this.instanceTemplateForm.instanceType,
      };

      if (this.provider === 'volcengine') {
        params.destinationResource = 'VolumeType';
        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/volcengine/describeAvailableResource', params)
          .then((res) => {
            const diskList
              = res.availableResourceList[0].AvailableResources[0].SupportedResources.map(item => item.Value) || [];
            this.diskList = diskList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'aliyun') {
        this.instanceTemplateFormLoading = true;
        params.destinationResource = 'SystemDisk';
        postRequest('/api/eda/common/aliyun/describeAvailableResource', params)
          .then((res) => {
            const diskList
              = res.availableResourceList[0].AvailableResources.AvailableResource[0].SupportedResources.SupportedResource.map(item => item.Value) || [];
            this.diskList = diskList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'huaweicloud') {
        this.instanceTemplateFormLoading = true;
        params.destinationResource = 'SystemDisk';
        postRequest('/api/eda/common/huaweicloud/describeVolumeTypes', params)
          .then((res) => {
            const diskList = res.volumeTypeList;
            this.diskList = diskList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }
    },

    /**
     * 选择磁盘类型
     */
    changeDiskType(type) {
      if (this.instanceTemplateForm.diskType === 'ESSD2') {
        this.iopsMinNumber = 100;
        this.iopsMaxNumber = 256000;

        this.throuhputMinNumber = 100;
        this.throuhputMaxNumber = 4000;
        if (type !== 'copy') {
          this.instanceTemplateForm.iops = 100;
          this.instanceTemplateForm.throughput = 100;
        }
      }
      if (this.instanceTemplateForm.diskType === 'GPSSD2') {
        this.iopsMinNumber = 3000;
        this.iopsMaxNumber = 128000;
        this.throuhputMinNumber = 125;
        this.throuhputMaxNumber = 1000;

        if (type !== 'copy') {
          this.instanceTemplateForm.iops = 100;
          this.instanceTemplateForm.throughput = 125;
        }
      }
    },

    /**
     * 选择镜像
     */
    changeImage() {
      this.diskSizeMinNumber
        = this.imageList.find(item => item.ImageId === this.instanceTemplateForm.imageId).Size || 0;
      if (this.diskSizeMinNumber < 20) {
        this.diskSizeMinNumber = 20;
      }
      this.instanceTemplateForm.diskSpecs.diskSize = this.diskSizeMinNumber;
    },

    /**
     * 获取镜像列表
     */
    getImageList() {
      this.imageList = [];
      const params = {
        multiCloudAccountId: this.instanceTemplateForm.multiCloudAccountId,
        region: this.instanceTemplateForm.region,
        instanceTypeId: this.instanceTemplateForm.instanceType,
        visibility: this.instanceTemplateForm.imageVisibility,
      };

      if (this.provider === 'volcengine') {
        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/volcengine/describeImages', params)
          .then((res) => {
            this.imageList = res.imageInfoList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'aliyun') {
        if (this.instanceTemplateForm.imageVisibility === 'public') {
          params.imageOwnerAlias = 'system';
        }
        if (this.instanceTemplateForm.imageVisibility === 'private') {
          params.imageOwnerAlias = 'self';
        }
        if (this.instanceTemplateForm.imageVisibility === 'shared') {
          params.imageOwnerAlias = 'others';
        }

        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/aliyun/describeImages', params)
          .then((res) => {
            this.imageList = res.imageInfoList || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }

      if (this.provider === 'huaweicloud') {
        this.instanceTemplateFormLoading = true;
        postRequest('/api/eda/common/huaweicloud/describeImages', params)
          .then((res) => {
            const list = res.imageInfoList.map(item => ({
              ImageId: item.id,
              ImageName: item.name,
              Size: item.size,
            }));

            this.imageList = list || [];
            this.instanceTemplateFormLoading = false;
          })
          .catch(() => {
            this.instanceTemplateFormLoading = false;
          });
      }
    },
    /**
     * 获取云环境列表
     */
    getMultiCloudAccountList() {
      this.instanceTemplateFormLoading = true;
      const data = {
        offset: 0,
        limit: 999,
      };
      postRequest('/api/eda/common/multicloud/describeMultiCloudAccountList', data)
        .then((res) => {
          this.cloudEnvironmentList = res?.list;
          this.instanceTemplateFormLoading = false;
        })
        .catch(() => {
          this.instanceTemplateFormLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// table 背景颜色+padding10px
.table_box {
  background: #fff;
  padding: 10px;
  height: calc(100% - 52px);
  margin-top: 10px;

  .table {
    height: calc(100% - 52px);

    ::v-deep .el-table__body-wrapper {
      height: calc(100% - 52px);
      overflow-y: auto;
    }
  }

  //::v-deep .el-table__body-wrapper {
  //  height: calc(100% - 68px);
  //  overflow-y: auto;
  //}

  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.provider_div {
  img {
    width: 14px;
    height: 14px;
  }
}
</style>
